import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import VisuallyHidden from '@atlaskit/visually-hidden';

import { ErrorVector } from '@/common/displays/assets';
import { EmptySearchVector } from '@/common/displays/assets/empty-search-vector';

import { messages } from './messages';

const styles = cssMap({
	loadingState: {
		padding: token('space.300'),
	},
	emptyState: {
		paddingBlock: token('space.400'),
		paddingInline: token('space.300'),
	},
});

const SKELETON_ROW_COUNT = 4;

export const OrganizationsFlyoutLoadingState = () => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.loadingState} testId="organizations-flyout-loading">
			<VisuallyHidden aria-live="polite">{formatMessage(messages.loadingLabel)}</VisuallyHidden>
			<Stack space="space.300" grow="fill">
				{Array.from({ length: SKELETON_ROW_COUNT }, (_unused, index) => (
					<Skeleton
						key={index}
						width="100%"
						height="9px"
						borderRadius={token('radius.small')}
						isShimmering
					/>
				))}
			</Stack>
		</Box>
	);
};

export const OrganizationsFlyoutEmptyState = () => {
	const { formatMessage } = useIntl();
	const description = formatMessage(messages.emptyDescription);

	return (
		<Box xcss={styles.emptyState} testId="organizations-flyout-empty">
			<Stack alignInline="center" space="space.100">
				<EmptySearchVector />
				<Text size="small" color="color.text.subtle" align="center">
					{description}
				</Text>
			</Stack>
		</Box>
	);
};

export const OrganizationsFlyoutErrorState = () => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.emptyState} testId="organizations-flyout-error">
			<Stack alignInline="center" space="space.100">
				<ErrorVector alt={formatMessage(messages.errorImageAlt)} size="small" />
				<Text size="small" color="color.text.subtle" align="center">
					{formatMessage(messages.errorDescription)}
				</Text>
			</Stack>
		</Box>
	);
};
